'use strict';

module.exports = function runApp ( app ) {
    var gettext = require('mag-gettext').gettext;

    core.taskManager.runApp({
        visible: true,
        config: app,
        onerror: function ( error ) {
            if ( error === 0 ) {
                core.notify({
                    title: gettext('Network status: offline'),
                    icon: 'info'
                });
            } else {
                core.notify({
                    title: gettext('Service not available, try later'),
                    icon: 'info'
                });
            }
        }
    }, true);
};
